import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message } from 'antd';
import { LockOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { confirmReset } from '../firebase/auth'; // Importar Firebase auth
import { useNavigate, useLocation } from 'react-router-dom'; // Para gestionar la redirección
import '../assets/styles/ResetPassword.css';

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const navigate = useNavigate();
  const location = useLocation();
  const [oobCode, setOobCode] = useState('');

  useEffect(() => {
    // Obtener el código de verificación (oobCode) de la URL
    const params = new URLSearchParams(location.search);
    const code = params.get('oobCode');
    if (code) {
      setOobCode(code);
    } else {
      message.error('Código de verificación no válido');
    }
  }, [location]);

  const handlePasswordChange = async (values) => {
    setLoading(true);
    const { password } = values;

    try {
      // Confirmar el restablecimiento de la contraseña
      await confirmReset(oobCode, password);
      message.success('Contraseña actualizada correctamente');
      navigate('/signin'); // Redirigir al login después de restablecer la contraseña
    } catch (error) {
      setErrorMessage('Hubo un error inesperado')
      // setErrorMessage(error.message);
      message.error('Error al restablecer la contraseña');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-password-page">
      <div className="reset-password-container">
        <h2>Restablecer Contraseña</h2>
        <p>Por favor, ingresa tu nueva contraseña.</p>

        <Form
          name="reset_password"
          onFinish={handlePasswordChange}
          initialValues={{ password: '' }}
        >
          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Por favor ingresa una nueva contraseña' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Nueva contraseña"
              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            />
          </Form.Item>

          {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="reset-password-button"
              loading={loading}
            >
              Restablecer Contraseña
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default ResetPassword;
